<ng-container>
    <!--========== NEW BANNER FILTER========-->
    <section class="px-4 md:px-4 lg:p-0 w-full bg-white z-10 relative banner-filter">
        <!-- Fondo blanco y ancho completo -->
        <div class="py-10 header-filters w-full mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] flex flex-col h-auto min-h-40 justify-center gap-4"
            style="display:none !important;">
            <div class="header-dashboard">
                <!-- Breadcrumb -->
                <div
                    class="text-lg md:text-xl font-semibold mb-1 flex flex-row md:flex-row md:items-center gap-2 items-center">
                    <a class="text-lg md:text-xl text-gray-700 flex items-center gap-1">
                        {{ "words.catalogue" | translate }}
                    </a>
                    <!-- HIDDEN oculto texto burscar nav -->

                    <span
                        class="hidden text-gray-700 items-center gap-1 truncate w-1/3 md:w-2/3 lg:w-2/3 text-lg md:text-xl">
                        <i class="hidden fas fa-chevron-right text-xs"></i>
                        Nombre del curso buscar
                    </span>
                </div>
            </div>
            <!--filtros saved-->

            <msc-shared-topbar-filters id="filter-saved" [type]="'saved-content'" [(query)]="query"
                [(filters)]="filters" [(activeFilters)]="activeFilters" (queryChange)="search()" (filtersChange)="search()"></msc-shared-topbar-filters>

        </div>
    </section>

<!--VIEW CURSOS GURDADOS OFFICE-->
    <section
        class="section-content px-4 md:px-4 lg:p-0 mt-12 md:mt-0 relative z-10  mb-8 w-full mx-auto max-w-full lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">

        <div class="max-w-7xl mx-auto min-h-screen py-8 md:py-10 flex flex-col" infinite-scroll [scrollWindow]="false"
            [infiniteScrollThrottle]="500" (scrolled)="loadMore()" *ngIf="!searching && contents">

            <msc-empty-state *ngIf="contents.length === 0" [title]="'empty.content.search.title'"
                [description]="'empty.content.search.description'">
            </msc-empty-state>

            <div class="card-course-grid flex-grow w-full">
                <div class="mb-8"><h1 class="md:text-2xl text-xl font-semibold text-gray-700 whitespace-nowrap mb-1.5">{{ 'words.saved-courses' | translate }}</h1><p class="text-sm text-muted-foreground">{{ 'words.saved-courses-description' | translate }}</p></div>
                
                <div
                    class=" grid-catalogue grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-5 mb-8">
                    <ng-container *ngFor="let content of contents">
                        <div class="relative" [ngClass]="{'custom-width-card': contents.length <= 2}">
                            <content-card id="card-catalogue"
                                [origin]="content.subscribed === true ? '' : 'savedContent'" [content]="content"
                                [saved]="true"></content-card>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="container-contents__load-more col-12 col-xxs-12">
                <msc-load-more [loading]="loading" [pagination]="pagination" (onLoad)="loadMore()"></msc-load-more>
            </div>
            <msc-common-spinner *ngIf="searching"></msc-common-spinner>
        </div>
    </section>
</ng-container>